import { render, staticRenderFns } from "./toPrintBmb.vue?vue&type=template&id=a2f7e094&scoped=true"
import script from "./toPrintBmb.vue?vue&type=script&lang=js"
export * from "./toPrintBmb.vue?vue&type=script&lang=js"
import style0 from "./toPrintBmb.vue?vue&type=style&index=0&id=a2f7e094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f7e094",
  null
  
)

export default component.exports